var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymGatelys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Gatelys\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 8v1.311c0 .786-.637 1.422-1.422 1.422H5.422A1.422 1.422 0 014 9.311V8h4.8zM28 8v1.311c0 .786-.637 1.422-1.422 1.422h-1.956A1.422 1.422 0 0123.2 9.311V8H28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1a1 1 0 011 1v2h8a2 2 0 012 2v2H18v17h-4V8H4V6a2 2 0 012-2h8V2a1 1 0 011-1h2zM13.178 25h5.644c.098 0 .178.08.178.178V31h-6v-5.822c0-.098.08-.178.178-.178z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M29 31H7"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 17h2.154l1.2-4H3.2zM7 13l1.2 4h2.154l-1.2-4z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 17h2.154l1.2-4H22.9zM26.7 13l1.2 4h2.154l-1.2-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymGatelys);
export default __webpack_public_path__ + "static/media/BYM_Gatelys.480af8324a2710157c702efbffc90b7b.svg";
export { ForwardRef as ReactComponent };